import styled from 'styled-components'
import createComponentFromTagProp from './create-component-from-tag-prop'
import gridUnit from '../mixins/gridUnit'

const GridUnitComponent = createComponentFromTagProp({
  tag: 'div',
  prop: 'component',
  propsToOmit: ['width', 'visible'],
})

const GridUnit = styled(GridUnitComponent)`
  box-sizing: border-box;
  ${gridUnit}
`

export default GridUnit
